import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { localeRoute } from "./locale";

export const whiteLabelRoute = createRoute({
  getParentRoute: () => localeRoute,
  path: "/white-label",
  component: lazyRouteComponent(() => import("../pages/white-label")),
});
